<template >
  <!-- /https://vuetifyjs.com/en/components/text-fields/ -->

  <v-text-field

    type="number"
    :label="formDetail.title"
    v-model="nValue"
    :name="index"
    :rules="[rulesForm.required, rulesForm.min, rulesForm.max]"
  >
  <template v-slot:append-inner>
      <v-tooltip location="bottom" v-if="formDetail.description">
        <template v-slot:activator="{ props }">
          <v-icon v-bind="props" icon="mdi-help-circle-outline"></v-icon>
        </template>
        {{ formDetail.description }}
      </v-tooltip>
    </template>
  </v-text-field>

</template>
 
<script setup>
const props = defineProps({
  formDetail: {
    type: Object,
    required: true,
  },
  model: {
    type: Object,
    required: true,
  },
  index: {
    type: String,
    required: false,
  },
});
const { $form} = useNuxtApp()
let nValue = ref(props.model[props.index] ? props.model[props.index] : "");
const rulesForm = $form.getRules(props.formDetail,props.index);
</script>
